module.exports = __webpack_public_path__ + "img/page_image_3_4.44a8995b.svg";